<template>
    <div id="workLoadList">
      <div class="scrollTop" @click="toTop" v-show="toTopIsShow"><img src="../../assets/imgs/home/totop.png" alt=""></div>
      <div class="workload-body withgray">
       <div class="box">
         <el-row class="box-filter">
           <el-col :span="8" style="text-align: center;">
                <el-cascader style="width:80% !important" size="mini" filterable change-on-select clearable :options="userCascaders" @change="handleChange" @remove-tag="removeuser()" v-model="userIds" placeholder="选择人员">
                </el-cascader>
          </el-col>
           <el-col :span="6" style="text-align: center;">
             <el-select placeholder="请选择时间维度" size="mini" v-model="queryParams.dateType" @change="onSelectedBigDate" style="width:80% !important">
                <el-option :key="1" label="日报" :value="1"></el-option>
                <el-option :key="2" label="月报" :value="2"></el-option>
              </el-select>
           </el-col>
           <el-col :span="10" style="text-align: center;">
             <el-date-picker v-model="queryParams.sMonth" size="mini" style="width:90% !important" type="month" :editable="false" :clearable="false" placeholder="选择月" v-if="queryParams.dateType==2" @change="onSelectedMonth"></el-date-picker>
             <el-date-picker v-model="queryParams.sDate" size="mini" style="width:90% !important" type="date" :editable="false" :clearable="false" format="yy-MM-dd" v-if="queryParams.dateType==1" @change="onSelectedDate" value-format="yyyy-MM-dd" placeholder="开始时间" class="fixwidth"></el-date-picker>
           </el-col>
         </el-row>
      </div>  
       <div class="box withgray box-target" v-loading="loadings.tableLoading">
          <el-row>
              <el-col :span="12">任务数:<h1 class="box-target-value">{{this.targetDatas.taskNum}}</h1></el-col>
              <el-col :span="12">点数:<h1 class="box-target-value">{{this.targetDatas.pointNum}}</h1></el-col>
          </el-row>
       </div>
       <div class="box" style="margin-bottom: 10px;">
         <el-table :data="tableDatas" size="mini" stripe border v-loading="loadings.tableLoading" element-loading-text="加载中">
            <el-table-column show-overflow-tooltip prop="TaskName" label="任务" min-width="25%"></el-table-column>
            <el-table-column show-overflow-tooltip prop="IsVisited" label="完成数" min-width="25%"></el-table-column>
            <el-table-column show-overflow-tooltip prop="PointNum" label="点数" min-width="25%"></el-table-column>
          </el-table>
       </div>
      </div>
    </div>
  </template>
  <script>
  import { message,imgServerHost, getBaseUrl,getKPIRegionCascaderOption,getKPIRoleOption,GetWorkLoadReport,getWorkRoleByUser,getUserCascaderReport,GetPerformanceReport} from "../../api/api";
  import libs from "../../utils/libs";
  import moment from "moment";
  import store from "../../utils/storage";
  
  const animationDuration = 6000

  export default {
    data() {
      return {
        uid:0,
        title:'',
        searchLoading:false,
        showBack:false,
        imgHost:getBaseUrl(),
        loadings: {
          loading: false,
          tableLoading: false,
          importLoading: false
        },
        toTopIsShow:false,//控制回到顶部按钮是否显示
        curUser:{},
        targetDatas:{
          taskNum:0,
          pointNum:0
        },
        rankDatas:[],
        userCascaders:[],
        //cascaderProps: { label: "Name", value: "Key", children: "Children" },
        userIds:[],
        queryParams:{
          sDate:moment().format("YYYY-MM-DD"),
          eDate:moment().format("YYYY-MM-DD"),
          userId:1,
          selectUserId:'',
          dateType:2,
          sMonth:moment().format("YYYY-MM")
        },
        tableDatas:[],


      };
    },
    mounted() {
      this.uid=this.$route.params.uid;
      this.queryParams.userId=this.$route.params.uid;
      this.getUserCascader();
       this.search();
       //console.log(this.regionCascaders);
       
       
    },
    created(){
            var _this=this;
            window.onscroll=function () {
                //鼠标滚轮滚动距离超过10像素时，回到顶部按钮才显示
                let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                if(top>30){
                    _this.toTopIsShow=true;
                }else{
                    _this.toTopIsShow=false;
                }
            }
        },
    methods: {
      toBack(){
        this.search();
      },
       handleChange(value) {
        this.search();
      },
      getUserCascader() {
        getUserCascaderReport(this.uid).then(res => {
          if (res.data.Code != 1) return;
          this.userCascaders = res.data.Data;
        });
      },
      onSelectedBigDate(selVal){
        var today=moment().format("YYYY-MM-DD");
        this.queryParams.sDate=today;
      this.queryParams.sMonth=moment().format("YYYY-MM");
      this.search();
        //if(selVal==2) 
      },
     
      onSelectedMonth(){
        this.search();
      },
      onSelectedDate(){
        this.search();
      },
      removeuser(){
        this.search();
      },
      toTop(){
        let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
        if(document.documentElement.scrollTop>0) document.documentElement.scrollTop=0;
        if(document.body.scrollTop>0) document.body.scrollTop=0;
        if(window.pageYOffset>0) window.pageYOffset=0;
      },
      search(){
        this.loadings.tableLoading=true;
        var m=new Date(this.queryParams.sMonth);
        //console.log(this.userIds[this.userIds.length - 1]);
        if(this.queryParams.dateType==2) this.queryParams.sDate=m.getFullYear().toString()+'-'+((m.getMonth()+1)<10?('0'+(m.getMonth()+1).toString()):(m.getMonth()+1).toString()) +'-01';
        this.queryParams.selectUserId = this.userIds.length>0?this.userIds[this.userIds.length - 1]:'';
        console.log(this.queryParams);

        GetPerformanceReport(this.queryParams).then(res=>{
          if(res.data.Code!=1) return;
          //console.log(res.data.Data.datatable);
          this.targetDatas.taskNum=res.data.Data[0].datatable[0].TaskNum;
          this.targetDatas.pointNum=res.data.Data[0].datatable[0].PointNum;
          this.tableDatas=res.data.Data[1].datatable;
          this.loadings.tableLoading=false;
          //this.queryParams.sDate=moment().format("YYYY-MM-DD");
        }
        );
        //console.log(this.queryParams);
        
      },
    }
  };
  </script>
  
  <style scoped>
  @import "../../assets/css/kpi/kpi.css";
  </style>

  <style>
      .customWidth {
   min-width:320px;
}

      </style>


// WEBPACK FOOTER //
// src/components/kpi/Performance.vue